"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ErrorDisplay;
const jsx_runtime_1 = require("react/jsx-runtime");
const error_svg_1 = __importDefault(require("@/assets/img/error.svg"));
function ErrorDisplay(props) {
    const { message } = props;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col justify-center items-center w-full h-full p-4 bg-slate-100", children: [(0, jsx_runtime_1.jsx)("img", { className: "chart-gray", src: error_svg_1.default, width: 30, height: 30, alt: "" }), (0, jsx_runtime_1.jsx)("p", { className: "p-2 text-xs text-gray-400", children: message })] }));
}
